module.exports = __webpack_public_path__ + "img/KFC.f47bedd7.svg";